import './photo.scss';
import GLightbox from 'glightbox';

export default () => {
	GLightbox( {
		selector: '.glightbox-1',
		closeOnOutsideClick: false,
		touchNavigation: true,
	} );
};
